import { useState } from 'react'
import Card from '../components/Card'

export default function ColorPicker() {
  const [color, setColor] = useState('#3b82f6')

  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null
  }

  const rgbToHsl = (r, g, b) => {
    r /= 255
    g /= 255
    b /= 255
    const max = Math.max(r, g, b)
    const min = Math.min(r, g, b)
    let h, s, l = (max + min) / 2

    if (max === min) {
      h = s = 0
    } else {
      const d = max - min
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
      switch (max) {
        case r:
          h = ((g - b) / d + (g < b ? 6 : 0)) / 6
          break
        case g:
          h = ((b - r) / d + 2) / 6
          break
        case b:
          h = ((r - g) / d + 4) / 6
          break
        default:
          h = 0
      }
    }

    return {
      h: Math.round(h * 360),
      s: Math.round(s * 100),
      l: Math.round(l * 100),
    }
  }

  const rgb = hexToRgb(color)
  const hsl = rgb ? rgbToHsl(rgb.r, rgb.g, rgb.b) : { h: 0, s: 0, l: 0 }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="mb-6">
            <label className="label">Select Color:</label>
            <input
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              className="w-full h-32 rounded-lg cursor-pointer border-2 border-gray-300"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gray-50 rounded-lg p-4">
              <label className="block text-gray-700 font-semibold mb-2">HEX:</label>
              <div className="text-xl font-mono text-primary-600">{color.toUpperCase()}</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4">
              <label className="block text-gray-700 font-semibold mb-2">RGB:</label>
              <div className="text-xl font-mono text-primary-600">
                {rgb ? `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})` : 'N/A'}
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4">
              <label className="block text-gray-700 font-semibold mb-2">HSL:</label>
              <div className="text-xl font-mono text-primary-600">
                hsl({hsl.h}°, {hsl.s}%, {hsl.l}%)
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

